<template>
  <div>
    <div class="message">
      {{ message }}
    </div>

    <div class="small-action">
      {{ habit.get('smallAction') }}
    </div>
  </div>
</template>

<script>
import Mixin from './Mixin'
import emoji from 'node-emoji'

export default {
  mixins: [
    Mixin
  ],

  computed: {
    message () {
      return emoji.emojify('この習慣の小さな行動は？:thinking_face:')
    }
  }
}
</script>

<style lang="scss" scoped>
.message {
  font-size: 0.8rem;
  font-weight: 500;
  margin-bottom: 2px;
}

.small-action {
  font-weight: 500;
}
</style>
